<template>

  <v-date-picker
    v-on:change="onDateChange"
    width="290"
    class="mt-4 position"
    first-day-of-week="1"
    :value="yearMonthDay"
    :show-current="true"
    :locale="locale"
    :color="color"
    scrollable
  ></v-date-picker>

</template>

<script>
import { TimeStampHelper } from '../../util/TimeStamp'

export default {

  props: ['sharedTimeStamp', 'locale', 'color'],

  computed: {
    /**
     * The current date as string e.g. "2020-11-13"
     */
    yearMonthDay () {
      const isoString = this.sharedTimeStamp.toISOString()
      return TimeStampHelper.extractDate(isoString);
    }
  },

  methods: {
    /**
     * Make updated timestamp available
     */
    onDateChange (newDate) {
      const split = newDate.split('-');

      const year = split[0];
      const month = split[1];
      const day = split[2];

      // for setting the month it is required to
      // have values between 0 and 11
      const adaptedMonth = month - 1;

      this.sharedTimeStamp.setUTCFullYear(year, adaptedMonth, day);

      this.$emit('dateHasChanged', this.sharedTimeStamp);
    }
  }
}

</script>

<style scoped>
.position{
  position:absolute;
  top: 64px;
  left: 16px;
  z-index:2;
}
</style>



// WEBPACK FOOTER //
// app/components/datepicker/DatePicker.vue